module.exports = __webpack_public_path__ + "img/home-pic-7.acc3861d.jpg";